// aldoo-ra/Router/index.js
import { RouteReader } from "./reader"
class AldooRouter {
  static path(pathOrPaths, component) {
    RouteReader.registerRoutes(pathOrPaths, component)
    return this // Allow chaining
  }

  static resolve(pathname) {
    return RouteReader.resolve(pathname)
  }

  static clear() {
    RouteReader.clearCache()
  }

}

export { RouteReader }
export default AldooRouter
